export interface FolioDocumentType {
  id: string;
  name: string;
  defaultDisplayLabel: string;
  description: string;
  defaultPreviewImageUrl: string;
}

export const defaultFolioDocumentType: FolioDocumentType = {
  id: '',
  name: '',
  defaultDisplayLabel: '',
  description: '',
  defaultPreviewImageUrl: '',
};

export interface VelocityEngageFolioFolderDocument {
  id: string;
  type: FolioDocumentType;
  url: string;
  displayLabel: string;
  canDelete: boolean;
  featured: boolean;
  visible: boolean;
  previewUrl: string;
}

export const defaultVelocityEngageFolioFolderDocument = (
  displayLabel: string = ''
) => ({
  id: '',
  type: { ...defaultFolioDocumentType },
  url: '',
  displayLabel,
  canDelete: false,
  featured: false,
  visible: true,
  previewUrl: '',
});

export interface FolioFolder {
  id: string;
  displayLabel: string;
  type: string;
  documents: VelocityEngageFolioFolderDocument[];
}

export interface Setting {
  value: string;
  dataType: string;
}

export interface Folio {
  id: string;
  inventoryId: string;
  tenantId: string;
  folders: FolioFolder[];
  settings: Record<string, Setting>[];
}
